import './materials.css';
import { useParams } from "react-router-dom";
import { get, getBlob } from "../../services/api";
import { useUI } from "../../UIContext";
import { handleErr } from "../../utils/functions";
import { useEffect, useRef, useState } from "react";
import * as pdfjsLib from "pdfjs-dist";
import { createPdfViewer } from "./pdfViewer";

// prestart/prebuild copy the matching worker verbatim, bypassing Babel transforms.
pdfjsLib.GlobalWorkerOptions.workerSrc = `${process.env.PUBLIC_URL || ''}/pdfjs/pdf.worker.${pdfjsLib.version}.min.js`;

function Material() {
    const { id } = useParams();
    const { setMessage, setLoading } = useUI();
    const [moduleName, setModuleName] = useState('');
    const [pdfDocument, setPdfDocument] = useState(null);
    const viewerRef = useRef(null);

    useEffect(() => {
        document.documentElement.classList.add('material-reader-active');
        return () => {
            document.documentElement.classList.remove('material-reader-active');
        };
    }, [id]);

    useEffect(() => {
        let active = true;
        let documentTask;
        let pdfWorker;
        let loading = true;
        const finishLoading = () => {
            if (loading) {
                loading = false;
                setLoading(false);
            }
        };

        async function loadMaterial() {
            setLoading(true);
            setModuleName('');
            setPdfDocument(null);

            await get(
                `module/${id}`,
                true,
                setMessage,
                (response) => {
                    if (!active) {
                        return;
                    }

                    const moduleData = response?.data?.module || response?.data;
                    const loadedName = typeof moduleData?.name === 'string'
                        ? moduleData.name.trim()
                        : '';

                    setModuleName(loadedName);
                },
                () => {},
                () => {},
                'redirect',
                'redirect',
                'unauthorized'
            );
    
            if (!active) return;
            let blob;
            await getBlob(
                `module/${id}/material`,
                true,
                setMessage,
                (response) => { blob = response.data; },
                (err) => {
                    if (active) handleErr(setMessage, `Não foi possível carregar o material: ${err}`);
                },
                () => {},
                'redirect',
                'redirect',
                'unauthorized'
            );
            if (!active || !blob) return;
            const arrayBuffer = await blob.arrayBuffer();
            if (!active) return;
            pdfWorker = new pdfjsLib.PDFWorker();
            await pdfWorker.promise;
            if (!active) return;
            documentTask = pdfjsLib.getDocument({ data: arrayBuffer, worker: pdfWorker });
            const document = await documentTask.promise;
            if (active) setPdfDocument(document);
        }

        loadMaterial().catch((err) => {
            if (active) handleErr(setMessage, `Não foi possível carregar o material: ${err}`);
        }).finally(finishLoading);

        return () => {
            active = false;
            finishLoading();
            Promise.resolve(documentTask?.destroy()).catch(() => {})
                .finally(() => pdfWorker?.destroy());
        };
    }, [setLoading, setMessage, id]);

    useEffect(() => {
        if (!pdfDocument || !viewerRef.current) return;
        return createPdfViewer(viewerRef.current, pdfDocument, (err) => {
            handleErr(setMessage, `Não foi possível renderizar o material: ${err}`);
        });
    }, [pdfDocument, setMessage]);

    return (
        <section className='main-container-material'>

            <div className='material-content-shell'>
                <div className='material-headline'>
                    <h2>{moduleName ? `Material da Aula - ${moduleName}` : 'Material da Aula'}</h2>
                </div>

                <div className='material-viewer-frame'>
                    <div
                        className='material-pdf-viewer'
                        ref={viewerRef}
                        role='document'
                        aria-label='Material de apoio em PDF'
                    />
                </div>
            </div>
        </section>
    );
}

export default Material;
